import { useCallback } from "react";

import Button from "ds/components/Button";
import { ArrowLeft } from "components/icons/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageUserGuides } from "hooks/useAnalytics/pages/userGuides";
import useUserGuideGroup from "shared/UserGuides/useUserGuideGroup";

import useAssistantPanelLearnStore from "../../useStore";
import useAssistantPanelLearnActiveGuide from "../../useActiveGuide";

const AssistantPanelLearnNavigationBackButton = () => {
  const { navigationState, setNavigationState } = useAssistantPanelLearnStore();
  const { activeGuide, currentStep } = useAssistantPanelLearnActiveGuide();
  const trackEvent = useAnalytics({ page: AnalyticsPageUserGuides.UserGuides });

  const groupId =
    navigationState.level === "groups" ? "" : navigationState.groupId;
  const { userGuideGroup } = useUserGuideGroup({ id: groupId });

  const userGuideName = activeGuide?.metadata.title;
  const userGuideStep = currentStep?.title;

  const handleBack = useCallback(() => {
    if (navigationState.level === "chapters") {
      trackEvent("Back Button Clicked", {
        from: "chapters",
        to: "groups",
        userGuideName,
        userGuideStep,
      });
      setNavigationState({ level: "groups" });
    } else if (navigationState.level === "guide") {
      trackEvent("Back Button Clicked", {
        from: "guide",
        to: "chapters",
        userGuideName,
        userGuideStep,
      });
      setNavigationState({
        level: "chapters",
        groupId: navigationState.groupId,
      });
    }
  }, [navigationState, setNavigationState, trackEvent, userGuideName, userGuideStep]);

  if (navigationState.level === "groups") {
    return null;
  }

  const ariaLabel =
    navigationState.level === "guide" && userGuideGroup?.name
      ? `Back to ${userGuideGroup.name}`
      : "Back to overview";

  return (
    <Button
      variant="ghost"
      size="small"
      startIcon={ArrowLeft}
      onPress={handleBack}
      aria-label={ariaLabel}
    >
      Back
    </Button>
  );
};

export default AssistantPanelLearnNavigationBackButton;
